import {
  initIosProducts,
  loadSubscriptionsSuccess,
  initIosRequest,
  errorIosRequest
} from '../actions/subscriptions';
import { handleActions } from 'redux-actions';
import _ from 'lodash';

const initialState = {
  items: [],
  current: null,
  receipt: null,
  receiptLoading: true,
  receiptError: ''
};

export default handleActions(
  {
    [loadSubscriptionsSuccess]: (state, action) => {
      const subscriptions = action?.payload || [];
      const currentSubscriptions = _.filter(subscriptions, { isActive: true });

      return {
        ...state,
        items: subscriptions,
        current: currentSubscriptions[currentSubscriptions.length - 1]
      };
    },
    [initIosRequest]: (state, action) => {
      return {
        ...state,
        receiptLoading: true,
        receiptError: ''
      };
    },
    [initIosProducts]: (state, action) => {
      return {
        ...state,
        receipt: action.payload,
        receiptError: '',
        receiptLoading: false
      };
    },
    [errorIosRequest]: (state, action) => {
      return {
        ...state,
        receiptLoading: false,
        receiptError: action.payload ?? ''
      };
    }
  },
  initialState
);
